"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TelephoneForm = void 0;
var _zod = require("@hookform/resolvers/zod");
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _commonFormFields = require("@ori/common-form-fields");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _i18n = require("@ori/i18n");
var _axios = _interopRequireDefault(require("axios"));
var _react = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _constants = require("../../constants");
var _defaultTranslations = require("../../constants/defaultTranslations");
var _notificationContext = require("../../contexts/notificationContext");
var _phoneContext = require("../../contexts/phoneContext");
var _useTranslations = require("../../hooks/useTranslations");
var _ErrorCodeMapper = require("../../models/ErrorCodeMapper");
var _FetchResult = require("../../models/FetchResult");
var _FieldError = require("../../models/FieldError");
var _TranslationKey = require("../../models/TranslationKey");
var _utils = require("../../utils");
var _transformKeysToCamelCase = require("../../utils/transformKeysToCamelCase");
var _validationSchema = require("../../validationSchema");
var _ActionButton = require("../ActionButton");
var _Checkbox = require("../Checkbox");
var _ConfirmDeleteDialog = require("../ConfirmDeleteDialog");
var _ConnectWithWhatsApp = require("../ConnectWithWhatsApp");
var _DeleteButton = require("../DeleteButton");
var _Verify = require("../Verification/Verify");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const TelephoneForm = props => {
  const {
    telephoneMetadata,
    telephone,
    displayMode,
    selectedItem,
    setDisplayMode,
    hideFormHandler,
    isCheckoutSection,
    customerId
  } = props;
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    tenant
  } = (0, _phoneContext.usePhoneContext)();
  const {
    context
  } = (0, _notificationContext.useNotificationData)();
  const getDefaultValues = () => {
    if (selectedItem) {
      const item = telephone.find(tel => tel.telephoneId === selectedItem.value);
      if (item) {
        return _utils.TelephoneValuesMapper.toForm(item);
      }
    }
    const values = {
      connectWithWhatsApp: false,
      connectWithEWallet: false,
      isPrimary: false,
      isVerified: false,
      telephoneId: selectedItem?.value,
      telephoneNumber: '',
      telephoneType: 'Mobile'
    };
    return values;
  };
  const defaultValues = getDefaultValues();
  const phoneSchema = (0, _validationSchema.useGetSchema)(telephoneMetadata ?? []);
  const methods = (0, _reactHookForm.useForm)({
    mode: 'all',
    reValidateMode: 'onChange',
    defaultValues,
    resolver: (0, _zod.zodResolver)(phoneSchema)
  });
  const {
    reset,
    watch,
    setValue,
    setError,
    handleSubmit,
    formState: {
      isValid,
      isDirty,
      isSubmitting,
      isSubmitted
    }
  } = methods;
  const [confirmOpened, setConfirmOpened] = (0, _react.useState)(false);
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    refreshPhones
  } = (0, _phoneContext.usePhoneContext)();
  const values = watch();
  const isDisabled = isValid && values.telephoneNumber === '';
  const {
    operations,
    telephoneNumber,
    connections,
    isVerificationEnabled,
    isPrimary
  } = telephoneMetadata;
  const canDelete = operations?.delete?.isEnabled ?? false;
  const canDeletePrimary = operations?.deletePrimary?.isEnabled ?? false;
  const canEdit = operations?.update?.isEnabled ?? false;
  const confirmCanceled = (0, _react.useCallback)(() => {
    setConfirmOpened(false);
  }, [setConfirmOpened]);
  const phoneValues = values ?? defaultValues;
  const onSubmit = async data => {
    const newData = _utils.TelephoneValuesMapper.toDto(data);
    let oldTelephone;
    try {
      let result;
      if (displayMode === _constants.DisplayMode.Update) {
        if (selectedItem) {
          oldTelephone = telephone?.find(item => item.telephoneId === selectedItem.value);
        }
        const requestData = {
          ...oldTelephone,
          ...newData
        };
        const response = await (0, _globalApiClientReact.updateCustomerPhone)(api, customerId, (requestData.telephoneId ?? '').toString(), requestData);
        result = new _FetchResult.FetchResult(response.status, undefined);
      } else {
        const response = await (0, _globalApiClientReact.createCustomerPhone)(api, customerId, newData);
        result = new _FetchResult.FetchResult(response.status, response.data);
      }
      if (result.isSuccess()) {
        const isPhoneChanged = oldTelephone?.telephoneNumber !== newData.telephoneNumber;
        const isOnlyWhatsAppChanged = oldTelephone?.connections?.whatsApp !== newData?.connections?.whatsApp && !isPhoneChanged;
        const showVerificationCode = isVerificationEnabled && !isOnlyWhatsAppChanged && isPhoneChanged;
        if (typeof result.response === 'number') {
          const formOptions = {
            shouldValidate: true,
            shouldDirty: true
          };
          setValue('telephoneId', result.response, formOptions);
        }
        if (showVerificationCode) {
          setDisplayMode?.(_constants.DisplayMode.Verify);
        } else {
          setDisplayMode?.(_constants.DisplayMode.Hidden);
        }
        if (!data.isVerified) {
          context.notificationData.setNotificationData({
            isOpen: true,
            message: formatMessage(_TranslationKey.TranslationKey.savedSuccessfully),
            type: 'success'
          });
        }
        refreshPhones();
      } else {
        throw new Error('Error');
      }
    } catch (error) {
      if (_axios.default.isAxiosError(error) && error.response) {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
        if (error.response.data) {
          const errorResponse = (0, _transformKeysToCamelCase.transformKeysToCamelCase)(error.response.data);
          // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
          if (errorResponse.errors) {
            errorResponse.errors.forEach(err => {
              if (err.propertyName && err.code) {
                const errorMessage = (0, _FieldError.createValidationMessage)(_ErrorCodeMapper.ErrorCodeMapper.getLocalizationKey(err.code));
                setError('telephoneNumber', {
                  message: formatMessage(errorMessage.localization.id),
                  type: 'manual'
                });
              } else {
                setError('telephoneNumber', {
                  message: formatMessage(_TranslationKey.TranslationKey.errorOccured),
                  type: 'manual'
                });
              }
            });
          }
        }
      } else {
        context.notificationData.setNotificationData({
          isOpen: true,
          message: formatMessage(_TranslationKey.TranslationKey.errorOccured),
          type: 'error'
        });
      }
    }
  };
  const openConfirmDialog = () => setConfirmOpened(true);
  const cancelButtonHandler = () => {
    reset();
    hideFormHandler?.();
  };
  const renderWhatsAppCheckbox = () => {
    const connectWithWhatsApp = connections?.whatsApp?.isAvailable ?? false;
    if (!connectWithWhatsApp) {
      return null;
    }
    const connectWithWhatsAppProps = {
      isAvailable: connectWithWhatsApp,
      label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
          id: _TranslationKey.TranslationKey.thisIsMyWhatsAppNumber,
          defaultMessage: _defaultTranslations.defaultTranslations.thisIsMyWhatsAppNumber
        })
      })
    };
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConnectWithWhatsApp.ConnectWithWhatsApp, {
      ...connectWithWhatsAppProps,
      telephoneNumber: values.telephoneNumber,
      isShowLink: Boolean(values.connectWithWhatsApp)
    });
  };
  const phoneFieldConfig = {
    helperText: formatMessage(_TranslationKey.TranslationKey.phoneHelperText),
    initialValue: selectedItem?.label,
    customPlaceholder: formatMessage(_TranslationKey.TranslationKey.phonePlaceholder),
    customPlaceholderWithPrefix: formatMessage(_TranslationKey.TranslationKey.phonePlaceholderWithPrefix),
    helperTextWithPrefix: formatMessage(_TranslationKey.TranslationKey.tooltipPrefixPhone),
    labelWithPrefix: formatMessage(_TranslationKey.TranslationKey.labelWithPrefix),
    name: 'telephoneNumber',
    label: formatMessage(_TranslationKey.TranslationKey.labelWithPrefix),
    isEditable: canEdit,
    isAvailable: telephoneNumber?.isAvailable ?? false,
    isMandatory: telephoneNumber?.validation?.isMandatory ?? false,
    customTenant: tenant,
    customMaxWidth: 'initial'
  };
  const renderPrimaryCheckbox = (disabledBeforeVerification = false) => {
    const isSwitchPrimaryDisabled =
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    defaultValues.isPrimary || disabledBeforeVerification || !isPrimary?.isEditable || !telephone.length;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.FormControl, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Checkbox.CheckboxField, {
        name: "isPrimary",
        label: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
            id: _TranslationKey.TranslationKey.useAsPrimaryTelephone,
            defaultMessage: _defaultTranslations.defaultTranslations.useAsPrimaryTelephone
          })
        }),
        color: "primary",
        disabled: isSwitchPrimaryDisabled
      })
    });
  };
  const createMode = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.PhoneFieldByConfig, {
      ...phoneFieldConfig
    }), !isCheckoutSection && isPrimary?.isEditable ? renderPrimaryCheckbox(isVerificationEnabled) : null, renderWhatsAppCheckbox()]
  });
  const updateMode = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.PhoneFieldByConfig, {
      ...phoneFieldConfig
    }), isPrimary?.isEditable ? renderPrimaryCheckbox(isVerificationEnabled ? !values.isVerified : false) : null, renderWhatsAppCheckbox(), canDelete && !defaultValues.isPrimary || canDeletePrimary ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_DeleteButton.DeleteButton, {
      dataTestId: "delete-telephone-button",
      label: formatMessage(_TranslationKey.TranslationKey.deleteTelephone),
      onClick: openConfirmDialog
    }) : null]
  });
  const handleDelete = async () => {
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (values.telephoneId) {
      try {
        await (0, _globalApiClientReact.deleteCustomerPhone)(api, customerId, values.telephoneId);
        await refreshPhones();
        setConfirmOpened(false);
        hideFormHandler?.(_constants.DisplayFeedback.Delete);
      } catch (error) {
        context.notificationData.setNotificationData({
          isOpen: true,
          message: formatMessage(_TranslationKey.TranslationKey.errorOccured),
          type: 'error'
        });
      }
    }
  };
  const hideVerifyHandler = (0, _react.useCallback)(feedback => {
    hideFormHandler?.();
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (feedback) {
      hideFormHandler?.(feedback);
    }
  }, [hideFormHandler]);
  const renderVerifyDialog = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_commonFormFields.PhoneFieldByConfig, {
      ...phoneFieldConfig
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
      header: formatMessage(_TranslationKey.TranslationKey.verifyPhone),
      iconMapping: {
        success: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckCircle, {}),
        warning: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckCircle, {}),
        error: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckCircle, {}),
        info: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.CheckCircle, {})
      },
      severity: "success",
      open: displayMode === _constants.DisplayMode.Verify,
      onClose: cancelButtonHandler,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
        maxWidth: "330px",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Verify.Verify, {
          ...props,
          values: phoneValues,
          reset: reset,
          hideFormHandler: hideVerifyHandler
        })
      })
    })]
  });
  const modeCreate = displayMode === _constants.DisplayMode.Create ? createMode() : null;
  const modeUpdate = displayMode === _constants.DisplayMode.Update ? updateMode() : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactHookForm.FormProvider, {
      ...methods,
      children: [displayMode === _constants.DisplayMode.Verify ? isCheckoutSection ? renderVerifyDialog() : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Verify.Verify, {
        ...props,
        values: phoneValues,
        reset: reset,
        hideFormHandler: hideVerifyHandler
      }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
        onSubmit: handleSubmit(onSubmit),
        children: [modeCreate, modeUpdate, /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionButton.ActionButtons, {
          isTouchedForm: true,
          isValid: isValid,
          isSubmitting: isSubmitting,
          isSubmitted: isSubmitted,
          isDirty: isDirty,
          isDisabled: isDisabled,
          dataTestIdPrefix: "telephone",
          handleCancel: cancelButtonHandler,
          showCancelButton: telephone.length >= 1
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConfirmDeleteDialog.ConfirmDeleteDialog, {
        opened: confirmOpened,
        handleCancel: confirmCanceled,
        handleConfirm: handleDelete,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
          align: "center",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.FormattedMessage, {
            id: _TranslationKey.TranslationKey.confirmTelephoneDelete,
            defaultMessage: _defaultTranslations.defaultTranslations.confirmTelephoneDelete
          })
        })
      })]
    })
  });
};
exports.TelephoneForm = TelephoneForm;
